import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "components/ui/button";
import { SelectResult } from "./select-result";
import ErrorTerminal from "../error-terminal";
import { QueryResponseData } from "@/@types/query-response";

interface SelectResultsDialogProps {
  query: string;
  modalData: QueryResponseData | null;
  isDialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
}

export const SelectResultsDialog: React.FC<SelectResultsDialogProps> = ({
  // query,
  modalData,
  isDialogOpen,
  setDialogOpen,
}) => {
  return (
    <Dialog open={isDialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="rounded-md font-[550] text-sm p-2 px-4 flex items-center gap-2 transition-all ease-in-out duration-300"
        >
          Resultados do Último Select
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[1025px] z-[999] bg-white px-4">
        <DialogHeader>
          <DialogTitle>Resultados do Select</DialogTitle>
          <DialogDescription>
            Verifique seus dados de select para revisar sua query.
          </DialogDescription>
          <div className="w-full py-4">
            {modalData?.result_before?.error ? (
              <ErrorTerminal error={modalData?.result_before?.error || ""} />
            ) : (
              <SelectResult data={modalData?.result_before} />
            )}
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
